var taskMap = new Map();
export var addTask = function (id, task) {
    taskMap.set(id, task);
};
export var removeTask = function (id) {
    return taskMap.delete(id);
};
export var abortTask = function (id) {
    var task = taskMap.get(id);
    if (task) {
        task.abort();
        removeTask(id);
    }
};
